import React from "react"
import { Box } from "@mui/material"
import WaypointCardContent from "@/features/route/WaypointCardContent.jsx"
import WaypointEditSection from "@/features/route/WaypointEditSection.jsx"
import { INFO_CARD_BODY_SX } from "@/components/map/InfoCardParts"

// limits: resolveWeatherLimits shape; Delete lives in the card header (WaypointDeleteAction).
export default function WaypointCardBody({
  feature,
  routeType,
  sketch = false,
  edit = null,
  limits = null,
  color,
}) {
  return (
    <Box sx={INFO_CARD_BODY_SX}>
      {edit?.manual && edit?.onLegtypeChange ? (
        <WaypointEditSection
          nextLabel={edit.nextLabel}
          legtype={edit.legtype}
          onLegtypeChange={edit.onLegtypeChange}
          disabled={edit.disabled}
        />
      ) : null}
      <WaypointCardContent feature={feature} routeType={routeType} sketch={sketch} limits={limits} color={color} />
    </Box>
  )
}
